export const sparkles = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M18.8571 20.8571C19.4634 20.8571 20.0447 21.0979 20.4734 21.5266C20.902 21.9552 21.1429 22.5366 21.1429 23.1428C21.1429 22.5366 21.3837 21.9552 21.8123 21.5266C22.241 21.0979 22.8224 20.8571 23.4286 20.8571C22.8224 20.8571 22.241 20.6163 21.8123 20.1876C21.3837 19.759 21.1429 19.1776 21.1429 18.5714C21.1429 19.1776 20.902 19.759 20.4734 20.1876C20.0447 20.6163 19.4634 20.8571 18.8571 20.8571ZM18.8571 7.14283C19.4634 7.14283 20.0447 7.38365 20.4734 7.8123C20.902 8.24096 21.1429 8.82234 21.1429 9.42854C21.1429 8.82234 21.3837 8.24096 21.8123 7.8123C22.241 7.38365 22.8224 7.14283 23.4286 7.14283C22.8224 7.14283 22.241 6.90202 21.8123 6.47336C21.3837 6.04471 21.1429 5.46333 21.1429 4.85712C21.1429 5.46333 20.902 6.04471 20.4734 6.47336C20.0447 6.90202 19.4634 7.14283 18.8571 7.14283ZM10.8571 20.8571C10.8571 19.0385 11.5796 17.2943 12.8656 16.0084C14.1515 14.7224 15.8957 14 17.7143 14C15.8957 14 14.1515 13.2775 12.8656 11.9916C11.5796 10.7056 10.8571 8.96146 10.8571 7.14283C10.8571 8.96146 10.1347 10.7056 8.84873 11.9916C7.56277 13.2775 5.81863 14 4 14C5.81863 14 7.56277 14.7224 8.84873 16.0084C10.1347 17.2943 10.8571 19.0385 10.8571 20.8571Z"
      stroke="url(#paint0_linear_2079_244)"
      strokeWidth="2.28571"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2079_244"
        x1="13.7143"
        y1="4.85712"
        x2="13.7143"
        y2="23.1428"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00AEEF" />
        <stop offset="1" stopColor="#5C59E8" />
      </linearGradient>
    </defs>
  </svg>
);
